import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import get from 'lodash/get';
import split from 'lodash/split';

import { CssBaseline } from '@mui/material';
import styled from '@mui/material/styles/styled';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { logout } from '../../store/auth';
import logo from '../../assets/images/LightLevel_by_Veregy.svg';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import NewPasswordForm from './NewPasswordForm';

const Root = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100vw',
});

const Logo = styled('img')({
  transform: 'scale(1.75)',
});

const Main = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export default function Authentication() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.pathname === '/logout') {
      dispatch(logout());
    }
  }, [location, dispatch]);

  const renderForm = () => {
    let hash = get(split(location.hash, '?'), '0', '');
    if (hash === '' || hash === '#login' || hash.startsWith('#confirmed=')) {
      return <SignInForm />;
    } else if (hash === '#signup') {
      return <SignUpForm />;
    } else if (hash === '#forgot') {
      return <ForgotPasswordForm />;
    } else if (hash === '#newpassword') {
      return <NewPasswordForm />;
    }
    return null;
  };

  return (
    <Root>
      <CssBaseline />
      <Main>
        <Paper
          elevation={10}
          sx={{
            paddingTop: 8,
            paddingBottom: 4,
            paddingLeft: 4,
            paddingRight: 4,
          }}>
          <Grid container spacing={2}>
            <Grid item xs={12} mb={5}>
              <Logo
                src={logo}
                alt='LightLevel by Veregy'
                width={250}
                height={50}
              />
            </Grid>
            <Grid item xs={12}>
              {renderForm()}
            </Grid>
          </Grid>
        </Paper>
      </Main>
    </Root>
  );
}
